module.exports = __webpack_public_path__ + "static/logo-fast-company-ca2f3975348a7e19491f01bed5cf72f9.png";